import { render, staticRenderFns } from "./DocumentPortalOthers.vue?vue&type=template&id=18595f85&scoped=true&"
import script from "./DocumentPortalOthers.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentPortalOthers.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocumentPortalOthers.vue?vue&type=style&index=0&id=18595f85&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18595f85",
  null
  
)

export default component.exports